import axiosApi from "../axiosInstance";

const getGroupList = async () => {
    try {
        const response = await axiosApi.get(`/Group/getAllGroup`);
        return response?.data;
        
    } catch (error) {
        console.log("Error getLocationList===>:", error);
         return error?.response?.data;
    }
};

const addGroup = async (body) => {
    try {
        const response = await axiosApi.post(`Group/CreateGroup`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addLocation ===>", error);
        return error?.response?.data;
    }
};

export const groupService = {
    getGroupList,
    addGroup
}